var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"size":"small"},on:{"change":_vm.input},model:{value:(_vm.newValue),callback:function ($$v) {_vm.newValue=$$v},expression:"newValue"}},_vm._l((_vm.listData),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.name,"value":item.keyId}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }